<template>
	<div class="h-100 flex flex-col">
		<div class="inbox-title">
			<h1
				style="z-index: 9999; padding: 24px;"
				class="position-relative inbox-title-label text-left m-0 pl-0"
			>
				{{ activePartnerName }}
			</h1>
		</div>
		<div class="flex-1">
			<div v-if="iframeLoading || loading" class="engage-loader">
				<div class="engage-loader__spinner"></div>
				<h3 class="engage-loader__text">Loading...</h3>
			</div>
			<div v-else-if="error" class="engage-error h-100">
				<div class="engage-error__icon">
					<font-awesome-icon
						:icon="['fal', 'exclamation-triangle']"
						size="5x"
						style="color: #da4423;"
					/>
				</div>
				<h3 class="engage-error__title">
					Dashboard Temporarily Unavailable
				</h3>
			</div>
			<iframe
				v-show="!iframeLoading && !loading"
				:src="flowLineURLSrc"
				width="100%"
				max-width="1400px"
				min-height="1000px"
				style="height: 100%"
				@load="onIframeLoad"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
	computed: {
		flowLineURLSrc() {
			return this.engage?.url ? atob(this.engage.url) : ''
		},
		activePartnerName() {
			return this.active?.name || ''
		},

		...mapGetters({
			// partners module
			active: 'partners/active',
			isEngageApp: 'partners/isEngageApp',
			clarusAppType: 'partners/clarusAppType',
			engageOnlyAppWithoutAccess: 'partners/engageOnlyAppWithoutAccess',

			// engage module
			loading: 'engage/loading',
			error: 'engage/error',
		}),

		...mapState({
			engage: state => state.engage.engageProperties,
		}),
	},

	methods: {
		onIframeLoad() {
			this.iframeLoading = false
		},
		/**
		 * Determine the correct route based on current state and navigate if needed.
		 * Uses nextTick to prevent navigation conflicts.
		 */
		checkAndRedirect() {
			this.$nextTick(() => {
				// If user doesn't have engage access, redirect appropriately
				if (!this.isEngageApp) {
					if (
						this.clarusAppType &&
						this.$route.name !== 'app.calls'
					) {
						this.$router.push({ name: 'app.calls' }).catch(() => {})
						return
					}
					if (
						this.engageOnlyAppWithoutAccess &&
						this.$route.name !== 'app.fallback'
					) {
						this.$router
							.push({ name: 'app.fallback' })
							.catch(() => {})
						return
					}
				}

				// If user has engage access, ensure we're on engage route
				if (
					this.isEngageApp &&
					!this.clarusAppType &&
					this.$route.name !== 'app.engage'
				) {
					this.$router.push({ name: 'app.engage' }).catch(() => {})
					return
				}
			})
		},
		...mapActions('engage', ['getEngage']),
	},

	name: 'Engage',

	watch: {
		isEngageApp: {
			handler() {
				this.checkAndRedirect()
			},
			immediate: true,
		},
		clarusAppType: {
			handler() {
				this.checkAndRedirect()
			},
			immediate: true,
		},
		engageOnlyAppWithoutAccess: {
			handler() {
				this.checkAndRedirect()
			},
			immediate: true,
		},
		$route(to, from) {
			const partnerChanged = to.params.partner !== from.params.partner
			if (partnerChanged) {
				this.checkAndRedirect()
			}
		},
		active: {
			handler(newPartner, oldPartner) {
				const newPartnerId = newPartner?.id
				const oldPartnerId = oldPartner?.id
				if (newPartnerId && newPartnerId !== oldPartnerId) {
					this.getEngage()
				}
			},
			immediate: true,
		},

		'engage.expiry': {
			handler(newExpiry) {
				// newExpiry is in hours, call 1 hour before expiry
				const delay = (newExpiry - 1) * 60 * 60 * 1000
				if (delay > 0) {
					setTimeout(() => {
						this.getEngage()
					}, delay)
				}
			},
		},

		flowLineURLSrc() {
			// Whenever src changes → show loader again
			this.iframeLoading = true
		},
	},

	data() {
		return {
			iframeLoading: true,
		}
	},
}
</script>
